var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-renderer" }, [
    _c(
      "div",
      { style: { height: _vm.pagination.itemCount * _vm.itemHeight + "px" } },
      [
        _c(
          "div",
          {
            staticClass: "list-renderer__wrapper",
            style: {
              transform:
                "translate(0, " + _vm.previousItemCount * _vm.itemHeight + "px)"
            }
          },
          _vm._l(_vm.itemsToRender, function(item, itemIndex) {
            return _c(
              "div",
              {
                key: _vm.visibleItemWindowIndices.firstIndex + itemIndex,
                staticClass: "list-renderer__item",
                style: _vm.itemStyle
              },
              [
                _vm._t("default", null, null, {
                  itemIndex:
                    _vm.visibleItemWindowIndices.firstIndex + itemIndex,
                  item: item
                })
              ],
              2
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }